export enum DetectionFilterKeys {
  LABELS = 'labels',
  CONFIDENCES = 'confidencies',
  CREATE_MODES = 'modes',
  STATUS = 'emergencies',
}
